// src/components/SuccessModal.js
import React from 'react';
import { CheckCircle, X } from 'lucide-react';

const SuccessModal = ({
  isOpen,
  onClose,
  title = 'Success!',
  message = '',
  buttonText = 'OK',
  autoClose = false,
  autoCloseDelay = 3000,
}) => {
  React.useEffect(() => {
    if (isOpen && autoClose) {
      const timer = setTimeout(onClose, autoCloseDelay);
      return () => clearTimeout(timer);
    }
  }, [isOpen, autoClose, autoCloseDelay, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 anim-fadeIn"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)' }}
      onClick={onClose}
    >
      <div
        className="rounded-3xl shadow-2xl max-w-md w-full p-8 text-center anim-popIn relative"
        style={{ backgroundColor: 'var(--color-card-bg)', border: `1px solid var(--color-border)` }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 p-2 rounded-full hover:bg-gray-100 transition btn-2d"
          style={{ color: 'var(--color-secondary-text)' }}
        >
          <X size={18} />
        </button>

        {/* Success Icon */}
        <div className="flex justify-center mb-5">
          <div
            className="w-20 h-20 rounded-full flex items-center justify-center anim-pulseGlow"
            style={{ backgroundColor: 'rgba(22, 163, 74, 0.12)' }}
          >
            <CheckCircle
              size={48}
              className="anim-popIn"
              style={{ color: '#16a34a' }}
              strokeWidth={2.5}
            />
          </div>
        </div>

        {/* Title */}
        <h2
          className="text-2xl font-bold mb-3 anim-fadeInUp"
          style={{ color: 'var(--color-primary-text)' }}
        >
          {title}
        </h2>

        {/* Message */}
        {message && (
          <p
            className="text-sm leading-relaxed mb-6 anim-fadeInUp delay-100"
            style={{ color: 'var(--color-secondary-text)' }}
          >
            {message}
          </p>
        )}

        {/* Button */}
        <button
          onClick={onClose}
          className="w-full rounded-full py-3.5 font-bold btn-2d shadow-lg ripple-btn anim-fadeInUp delay-200"
          style={{
            background: 'linear-gradient(135deg, #16a34a 0%, #14532d 100%)',
            color: '#ffffff',
          }}
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default SuccessModal;